import { styled, Switch as MuiSwitch, SwitchProps } from "@mui/material";
import { SWITCH_COLORS } from "../../constants";

const StyledSwitch = styled((props: SwitchProps) => (
  <MuiSwitch
    focusVisibleClassName=".Mui-focusVisible"
    disableRipple
    {...props}
  />
))(({ theme }) => ({
  width: 68,
  height: 34,
  padding: 0,
  borderRadius: 16,
  "& .MuiSwitch-switchBase": {
    padding: 0,
    margin: 2,
    transitionDuration: "300ms",
    "&.Mui-checked": {
      transform: "translateX(34px)",
      color: SWITCH_COLORS.checkedThumbBackground,
      "& + .MuiSwitch-track": {
        backgroundColor: SWITCH_COLORS.background,
        opacity: 1,
        border: 0,
      },
      "&.Mui-disabled + .MuiSwitch-track": {
        opacity: 0.5,
      },
    },
    "&.Mui-focusVisible .MuiSwitch-thumb": {
      color: SWITCH_COLORS.background,
      border: "6px solid #fff",
    },
    "&.Mui-disabled .MuiSwitch-thumb": {
      color: theme.palette.grey[100],
    },
    "&.Mui-disabled + .MuiSwitch-track": {
      opacity: 0.7,
    },
  },
  "& .MuiSwitch-thumb": {
    boxSizing: "border-box",
    width: 30,
    height: 30,
  },
  "& .MuiSwitch-track": {
    borderRadius: 34 / 2,
    backgroundColor: SWITCH_COLORS.trackBackground,
    opacity: 1,
    transition: theme.transitions.create(["background-color"], {
      duration: 500,
    }),
  },
}));

export const Switch = ({ ...restProps }: SwitchProps) => {
  return <StyledSwitch {...restProps} />;
};

export default Switch;
